import { render } from "./DeletedAdminsList.vue?vue&type=template&id=986fa804"
import script from "./DeletedAdminsList.vue?vue&type=script&lang=js"
export * from "./DeletedAdminsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__